<template>
    <step-choice
        tab-class="tab-diabetes"
        headline="Haben Sie die Diagnose Typ-2-Diabetes?"
        :options="options"
        @answer="$emit('answer', $event)"
    >
        <template slot="footer">
            <p class="ce-note new-text-md">
                <span class="ce-mark">
                    <svg width="36" height="26" viewBox="0 0 36 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5264 0C12.9445 1.19815e-05 13.3623 0.0209632 13.7783 0.0634766V3.88574C13.363 3.83411 12.9446 3.81314 12.5264 3.82227C7.68386 3.82227 3.75788 7.81488 3.75781 12.7402C3.75781 17.6657 7.68382 21.6582 12.5264 21.6582C12.9447 21.6673 13.363 21.6464 13.7783 21.5947V25.417C13.3623 25.4595 12.9445 25.4805 12.5264 25.4805C5.60844 25.4805 0 19.7765 0 12.7402C6.9216e-05 5.70398 5.60848 0 12.5264 0ZM33.8174 0C34.2357 -1.2249e-08 34.6541 0.0209287 35.0703 0.0634766V3.88574C34.6548 3.83407 34.2359 3.81311 33.8174 3.82227C29.6987 3.82204 26.1346 6.73726 25.252 10.8291H32.5654V14.6514H25.252C26.1345 18.7433 29.6987 21.6584 33.8174 21.6582C34.2359 21.6674 34.6548 21.6464 35.0703 21.5947V25.417C34.6541 25.4595 34.2357 25.4805 33.8174 25.4805C26.8996 25.4803 21.292 19.7765 21.292 12.7402C21.2921 5.70407 26.8996 0.000141307 33.8174 0Z" fill="url(#paint0_linear_32430_40986)"/>
                    <defs>
                    <linearGradient id="paint0_linear_32430_40986" x1="-6.60121" y1="8.76819" x2="8.41921" y2="38.8069" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#8B65E6"/>
                    <stop offset="1" stop-color="#5937B7"/>
                    </linearGradient>
                    </defs>
                    </svg>
                </span>
                <span>Vitadio ist ein Medizinprodukt mit CE-Kennzeichnung</span>
            </p>
        </template>
    </step-choice>
</template>

<script>
import StepChoice from './StepChoice'

export default {
    components: { StepChoice },

    data() {
        return {
            options: [
                { label: 'Ja', value: true, icon: 'yes' },
                { label: 'Nein', value: false, icon: 'no' }
            ]
        }
    }
}
</script>
